import {Box, Button, Center, Icon} from '@chakra-ui/react'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {ReactComponent as ArrowRightIcon} from '@assets/svgs/arrow_right.svg'
import GlobalMic3 from '@components/GlobalMic3'
import {CommonColors} from '@utils/CommonStyles'
import {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateMessages,
  updateIsLoadingBot,
  updateIsFinish,
  updateAudio,
  updateIsShowSample,
  updateCurrentIndexContent,
  updateNumberRecorded,
  updatePracticeData,
  reset,
  updateAudioFileUser,
  updateIsRecording,
} from '@redux/learn-part-three/learnPartThree'
import {useLocation, useNavigate} from 'react-router-dom'
import {audioRef} from '@utils'
import {ReactComponent as CupIcon} from '@assets/svgs/cup.svg'
import {ReactComponent as EyeIcon} from '@assets/svgs/eye.svg'
import {ReactComponent as EyeOffIcon} from '@assets/svgs/eye_off.svg'
import learnPartThreeRequest from '@apis/learn-part-three'
import {PATH} from '@utils/Const'

const Footer = () => {
  const {
    currentContent,
    currentIndexContent,
    audio,
    isShowFooter,
    numberRecorded,
    isDisableBtn,
    isLoadingBot,
    isFinish,
    isShowSample,
    messages,
    sessionId,
    practiceData,
  } = useSelector((state: any) => state.learnPartThree)
  const {entry_point, task_id} = useLocation()?.state || {}
  const [isLoadingMic, setIsLoadingMic] = useState(false)
  const [isRecording, setIsRecording] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const micRef = useRef<any>(null)

  useEffect(() => {
    if (currentContent?.type !== 'P3_WAITTING_SCREEN') return

    const timer = setTimeout(() => {
      dispatch(updateCurrentIndexContent(currentIndexContent + 1))
      dispatch(updatePracticeData(null))
      dispatch(updateNumberRecorded(0))
      dispatch(updateIsShowSample(false))

      if (audioRef.current) {
        audioRef.current.pause()
      }
    }, 5000)

    return () => clearTimeout(timer)
  }, [currentContent])

  useEffect(() => {
    if (!currentContent) return
    let audioData = {
      time: Date.now(),
      url: '',
    }

    switch (currentContent?.type) {
      case 'P3_OVERVIEW':
      case 'P3_GET_IDEA':
      case 'P3_PRACTICE_IDEA':
      case 'P3_WAITTING_SCREEN':
      case 'P3_PRACTICE_LESSON_BODY':
      case 'P3_PRACTICE_LESSON_FRAME_1':
      case 'P3_PRACTICE_LESSON_FRAME_2':
        audioData.url = currentContent?.introduction_audio
        break
      default:
        break
    }

    if (currentContent?.type != 'P3_SUMMARY') {
      dispatch(updateAudio(audioData))
    }
  }, [currentContent])

  useEffect(() => {
    if (!audio?.url || !audioRef.current) return

    let isSubscribed = true

    const playAudio = async () => {
      try {
        if (!isSubscribed) return

        if (audioRef.current) {
          audioRef.current.pause()
          audioRef.current.currentTime = 0
          audioRef.current.src = audio?.url

          await audioRef.current.load()

          if (isSubscribed && audioRef.current) {
            await audioRef.current.play()
          }
        }
      } catch (error) {
        console.error('Error playing audio:', error)
      }
    }

    playAudio()

    return () => {
      isSubscribed = false
      if (audioRef.current) {
        audioRef.current.pause()
        audioRef.current.src = ''
      }
    }
  }, [audio?.time])

  const handleNextContent = () => {
    dispatch(updateCurrentIndexContent(currentIndexContent + 1))
    dispatch(updatePracticeData(null))
    dispatch(updateNumberRecorded(0))
    dispatch(updateIsShowSample(false))

    try {
      learnPartThreeRequest.saveStep({
        session_id: sessionId,
        step: currentContent?.step,
      })
    } catch (error) {}

    if (audioRef.current) {
      audioRef.current.pause()
    }
  }

  const stt = async (recordingBlob: Blob) => {
    try {
      let file = new File([recordingBlob], 'audio.wav', {type: 'audio/wav'})
      const formData = new FormData()
      formData.append('audio-file', file)
      const res = await learnPartThreeRequest.stt(formData)
      dispatch(updateAudioFileUser(file))
      return res?.data?.data?.result
    } catch (error) {
      return null
    }
  }

  const getBandScore = async (recordingBlob: Blob, userAnswer: string) => {
    try {
      let file = new File([recordingBlob], 'audio.wav', {type: 'audio/wav'})
      const formData = new FormData()
      formData.append('audio_file', file)
      formData.append('user_answer', userAnswer || '')

      const params = {
        session_id: sessionId,
        data: formData,
      }

      const res = await learnPartThreeRequest.getScore(params)
      return res?.data?.data
    } catch (error) {
      return null
    }
  }

  const handleStartRecording = () => {
    setIsRecording(true)
    dispatch(updateIsRecording(true))
    if (audioRef.current) {
      audioRef.current.pause()
    }
  }

  const handleRecordingComplete = async (recordingBlob: Blob) => {
    setIsLoadingMic(true)

    if (currentContent?.type === 'P3_SUMMARY') {
      const result = await stt(recordingBlob)

      let messageUser = {
        content: result?.text,
        message_type: 'USER',
      }

      dispatch(updateMessages([...messages, messageUser]))
      dispatch(updateIsLoadingBot(true))

      try {
        const bandScoreData = await getBandScore(recordingBlob, result?.text)

        let audioData = {
          time: Date.now(),
          url: bandScoreData[0]?.data?.audio,
        }

        dispatch(updateAudio(audioData))
        dispatch(updateMessages([...messages, messageUser, ...bandScoreData]))
        dispatch(
          updateIsFinish(bandScoreData[bandScoreData.length - 1]?.is_finish),
        )
      } catch (error) {
        let messageError = {
          data: {
            text: 'Có lỗi xảy ra, vui lòng thử lại!',
          },
          message_type: 'TEXT',
        }

        dispatch(updateMessages([...messages, messageUser, messageError]))
      }

      dispatch(updateIsLoadingBot(false))
      setIsLoadingMic(false)
      setIsRecording(false)
      dispatch(updateIsRecording(false))
      return
    }

    if (
      currentContent?.type === 'P3_PRACTICE_LESSON_FRAME_1' ||
      currentContent?.type === 'P3_PRACTICE_LESSON_FRAME_2'
    ) {
      try {
        let file = new File([recordingBlob], 'audio.wav', {type: 'audio/wav'})
        const formData = new FormData()
        formData.append('audio-file', file)
        formData.append('type', currentContent?.type)
        const res = await learnPartThreeRequest.getFramesScore({
          session_id: sessionId,
          data: formData,
        })
        dispatch(updatePracticeData(res?.data?.data))
      } catch (error) {}

      setIsLoadingMic(false)
      setIsRecording(false)
      dispatch(updateIsRecording(false))
      dispatch(updateNumberRecorded(numberRecorded + 1))
      return
    }

    try {
      let file = new File([recordingBlob], 'audio.wav', {type: 'audio/wav'})
      const formData = new FormData()
      formData.append('audio-file', file)
      const res = await learnPartThreeRequest.stt(formData)
      dispatch(updatePracticeData(res?.data?.data))
    } catch (error) {}

    setIsLoadingMic(false)
    setIsRecording(false)
    dispatch(updateIsRecording(false))
    dispatch(updateNumberRecorded(numberRecorded + 1))
  }

  const handleFinish = () => {
    dispatch(reset())

    if (entry_point === 'ROADMAP') {
      navigate(PATH.ROADMAP_SUMMARY, {
        state: {
          task_id: task_id,
        },
      })
    } else {
      navigate(-1)
    }
  }

  if (!isShowFooter || currentContent?.type === 'P3_WAITTING_SCREEN') {
    return (
      <Center height={'100px'}>
        <audio ref={audioRef} style={{display: 'none'}}>
          Trình duyệt của bạn không hỗ trợ thẻ audio.
        </audio>
      </Center>
    )
  }

  return (
    <>
      {currentContent?.type === 'P3_SUMMARY' && (
        <Center height={'100px'} gap={'30px'}>
          {isFinish ? (
            <GlobalButton
              gap={2}
              isDisabled={isLoadingMic || isLoadingBot || isRecording}
              onClick={handleFinish}>
              {'Hoàn thành'}
              <Icon
                as={CupIcon}
                sx={{
                  width: '16px',
                  height: '16px',
                  path: {
                    stroke: 'white',
                  },
                }}
              />
            </GlobalButton>
          ) : (
            <GlobalMic3
              ref={micRef}
              isLoading={isLoadingMic}
              handleStartRecording={handleStartRecording}
              handleRecordingComplete={handleRecordingComplete}
            />
          )}
        </Center>
      )}
      {(currentContent?.type === 'P3_PRACTICE_IDEA' ||
        currentContent?.type === 'P3_PRACTICE_LESSON_FRAME_1' ||
        currentContent?.type === 'P3_PRACTICE_LESSON_FRAME_2' ||
        currentContent?.type === 'P3_PRACTICE_LESSON_BODY') && (
        <Center height={'100px'} gap={'30px'}>
          {currentContent?.type === 'P3_PRACTICE_LESSON_FRAME_1' ||
          currentContent?.type === 'P3_PRACTICE_LESSON_FRAME_2' ? (
            <Button
              isDisabled={practiceData}
              w={'118px'}
              bg={isShowSample ? '#D6EBFF' : 'white'}
              py={'23px'}
              borderRadius={'100px'}
              border={`1px solid ${CommonColors.primary}`}
              color={CommonColors.primary}
              leftIcon={
                <Icon
                  as={isShowSample ? EyeOffIcon : EyeIcon}
                  sx={{
                    path: {
                      stroke: CommonColors.primary,
                    },
                  }}
                />
              }
              onClick={() => dispatch(updateIsShowSample(!isShowSample))}>
              {isShowSample ? 'Ẩn mẫu' : 'Hiện mẫu'}
            </Button>
          ) : (
            <Box w={'118px'} />
          )}
          <GlobalMic3
            ref={micRef}
            isLoading={isLoadingMic}
            handleStartRecording={handleStartRecording}
            handleRecordingComplete={handleRecordingComplete}
          />
          <GlobalButton
            isDisabled={isDisableBtn || isRecording}
            py={'23px'}
            color={'white'}
            borderRadius={'100px'}
            rightIcon={
              <Icon
                as={ArrowRightIcon}
                sx={{
                  path: {
                    stroke: 'white',
                  },
                }}
              />
            }
            onClick={handleNextContent}
            bg={CommonColors.primary}>
            {currentContent?.type === 'P3_PRACTICE_LESSON_FRAME_2'
              ? 'Kiểm tra thử'
              : 'Tiếp tục'}
          </GlobalButton>
        </Center>
      )}
      {(currentContent?.type === 'P3_OVERVIEW' ||
        currentContent?.type === 'P3_GET_IDEA') && (
        <Center height={'100px'}>
          <GlobalButton gap={2} onClick={handleNextContent}>
            {currentContent?.type === 'P3_GET_IDEA'
              ? 'Hoàn thiện ý'
              : 'Bắt đầu'}
            <Icon
              as={ArrowRightIcon}
              sx={{
                width: '16px',
                height: '16px',
                path: {
                  stroke: 'white',
                },
              }}
            />
          </GlobalButton>
        </Center>
      )}

      <audio ref={audioRef} style={{display: 'none'}}>
        Trình duyệt của bạn không hỗ trợ thẻ audio.
      </audio>
    </>
  )
}

export default Footer
